module.exports = "/images/vendor/jquery-ui/themes/base/ui-icons_777620_256x240.png?efbf84f0f6384f5c303ea15ebb299a08";